import React from "react";
import { useTranslation } from "react-i18next";

import { noop } from "../../../../utils/noop";
import { Icon } from "../../../Icon/Icon";
import "./LoginOnboardingInterstitial.css";

export const LoginOnboardingInterstitial = ({
  showButton = true,
  onButtonClick = noop,
}) => {
  const { t } = useTranslation();

  return (
    <div className="LoginOnboardingInterstitial">
      <div className="LoginOnboardingInterstitial__icon">
        <Icon name="iconUpdatePassword" width="45" height="45" />
      </div>
      <div className="LoginOnboardingInterstitial__info">
        <strong>{t("onboardingForm.interstitialWelcome")}</strong>
        <br />
        {t("onboardingForm.interstitialTimeToRenew")}
      </div>
      {showButton && (
        <div
          className="LoginOnboardingInterstitial__btn"
          onClick={onButtonClick}
        >
          {t("onboardingForm.interstitialRenewButton")}
        </div>
      )}
    </div>
  );
};
